(function () {
  'use strict';

  angular
    .module('messageAdmin')
    .controller('MessageReceivePopupCtrl', MessageReceivePopupCtrl);

  function MessageReceivePopupCtrl($uibModalInstance, modalParams) {
    var vm = this;

    vm.model = {
      title: modalParams.title,
      data: modalParams.data || [],
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    };

    vm.onYesClick = function() {
      $uibModalInstance.close('YES');
    };

    vm.onNoClick = function() {
      $uibModalInstance.close();
    };
  }
}());
